import * as Config from '../../../config';
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import MainRoute from '../route/MainRoute';
import CustomRoute from '../custom/-APP_TARGET/content/CustomRoute';
import ButtonFeedback from '../feedback/ButtonFeedback'

// Entrypoint for all kind of content
function ConnectedContentManager({ width, height }) {

  return (
    <div id={`cm-v2`} className={`content-manager-v2`} style={{ width , height }}>
      <MainRoute />
      <CustomRoute />
      {Config.MOD_FEEDBACK && <ButtonFeedback />}
    </div>
  );
}

ConnectedContentManager.propTypes = {
  width: PropTypes.any,
  height: PropTypes.any
}

const ContentManager = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height - Config.TAB_BAR_GUTTER
  })
)(ConnectedContentManager);

export default ContentManager;
